import React from "react"
import styled from "styled-components"

const EmptyStateWrapper = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    margin-top:2rem;

    p{
        font-size:1.6rem;
        text-align:center;
        color:var(--color-gray);
        font-weight:400;
    }

`

type Props = {
    message: string,
}

const EmptyState = (props: Props) => {
    return (
        <EmptyStateWrapper>
            <p>{props.message}</p>
        </EmptyStateWrapper>
    )
}

export default EmptyState